import React, { useState, useEffect } from "react";
import { useLogin, useNotify } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";

import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoginPage = ({ theme }) => {
    const login = useLogin();
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const { searchParams } = new URL(window.location.href);
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        console.log("useEffect called")
        // If code is present, we came back from the provider
        if (code && state) {
            setLoading(true);
            login({ code, state }).catch (error => {
                setLoading(false);
                console.log("failed to log in",error);
            });
        }
    }, [login]);

    const submit = e => {
        e.preventDefault();
        setLoading(true);
        // call the login callback returned by the useLogin hook
        login().catch(() => notify("Invalid login?"));
    };

  return (
    <ThemeProvider theme={theme}>
        <CardActions>
             <Button
                 // className={classes.button}
                 variant="outlined"
                 type="submit"
                 color="primary"
                 onClick={submit}
                 disabled={loading}
             >
                 {loading && (
                     <CircularProgress
                         //       className={classes.icon}
                         size={18}
                         thickness={2}
                     />
                 )}
                 Login With Github
             </Button>
         </CardActions>
      </ThemeProvider>
  );
};

export default LoginPage;
